(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  if (!customElements.get('footer-brandmark')) {
    customElements.define('footer-brandmark', class FooterBrandmark extends HTMLElement {
      connectedCallback() {
        this.frames = Array.prototype.slice.call(this.querySelectorAll('img'));
        if (this.frames.length < 2) return;

        this.index = 0;
        this.step = 0;
        this.speed = Math.max(parseFloat(this.dataset.speed) || 1, 0.2) * 1000;
        this.hold = 2000;
        this.cycleLimit = this.frames.length * 2;
        const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (reduceMotion) return;

        this.schedule(this.speed);
      }

      schedule(delay) {
        this.timer = window.setTimeout(() => this.tick(), delay);
      }

      tick() {
        this.frames[this.index].classList.remove('is-active');
        this.index = (this.index + 1) % this.frames.length;
        this.frames[this.index].classList.add('is-active');
        this.step += 1;

        const delay = this.step % this.cycleLimit === 0 ? this.hold : this.speed;
        this.schedule(delay);
      }

      disconnectedCallback() {
        if (this.timer) window.clearTimeout(this.timer);
      }
    });
  }

  if (!customElements.get('localization-form')) {
    customElements.define('localization-form', class LocalizationForm extends HTMLElement {
      constructor() {
        super();
        this.form = this.querySelector('form');
        this.select = this.form && this.form.querySelector('select');
        if (this.select) this.select.addEventListener('change', this.onChange.bind(this));
      }

      onChange(event) {
        event.preventDefault();
        this.form.submit();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["popup"]) return;
  try {
    
  class Popup extends HTMLElement {
    constructor() {
      super();
      const _this = this;

      if (typeof localStorage === 'object') {
        try {
          localStorage.setItem('localStorage', 1);
          localStorage.removeItem('localStorage');
        } catch (e) {
          Storage.prototype._setItem = Storage.prototype.setItem;
          Storage.prototype.setItem = function() {};
        }
        
        var date = Math.round(Date.now() / 1000),
            days = Math.floor((date - localStorage.getItem('popDate')) / 60 / 60 / 24);
        
        if (localStorage.getItem('popState') != 'shown' || days >= Math.max(this.dataset.hide, 0)) {
          setTimeout(() => {
            _this.parentNode.querySelector('[type="checkbox"]').checked = true;
            localStorage.setItem('popState', 'shown');
            localStorage.setItem('popDate', date);
          }, parseInt(this.dataset.delay) * 1000);
        }
      }
    }
  }
  customElements.define('pop-up', Popup);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-grid"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('load-more')) {
    customElements.define('load-more', class LoadMore extends HTMLElement {
      constructor() {
        super();
        this.addEventListener('click', this.loadMore.bind(this));
      }

      loadMore(event) {
        event.preventDefault();
        var page = parseInt(event.target.dataset.page) + 1;
        this.dispatchEvent(new CustomEvent('collection:paginate', { bubbles: true, detail: { page: page } }));
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["scrolling-bar"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('scrolling-bar')) {
    customElements.define('scrolling-bar', class ScrollingBar extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;

        this.track = this.querySelector('.scrolling-bar__track');
        this.original = this.querySelector('.scrolling-bar__group');
        if (!this.track || !this.original) return;

        this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.fill = this.fill.bind(this);

        this.fill();
        this.playVideos();

        this.original.querySelectorAll('img').forEach((img) => {
          if (!img.complete) img.addEventListener('load', this.fill, { once: true });
        });

        if (typeof ResizeObserver !== 'undefined') {
          this.resizeObserver = new ResizeObserver(() => this.fill());
          this.resizeObserver.observe(this);
        } else {
          window.addEventListener('resize', this.fill, { passive: true });
        }

        if ('IntersectionObserver' in window) {
          this.intersectionObserver = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
              this.classList.toggle('is-paused', !entry.isIntersecting);
              this.toggleVideos(entry.isIntersecting);
            });
          }, { threshold: 0.05 });
          this.intersectionObserver.observe(this);
        }
      }

      fill() {
        if (this.reduceMotion) {
          this.track.querySelectorAll('.scrolling-bar__group[data-clone]').forEach((clone) => clone.remove());
          return;
        }

        this.track.querySelectorAll('.scrolling-bar__group[data-clone]').forEach((clone) => clone.remove());

        const viewportWidth = this.offsetWidth || 0;
        if (!viewportWidth || !this.original.offsetWidth) return;

        let copies = 1;
        while (this.track.scrollWidth < viewportWidth * 2 && copies < 12) {
          const clone = this.original.cloneNode(true);
          clone.setAttribute('aria-hidden', 'true');
          clone.dataset.clone = 'true';
          clone.querySelectorAll('[id]').forEach((el) => el.removeAttribute('id'));
          clone.querySelectorAll('a').forEach((el) => el.setAttribute('tabindex', '-1'));
          this.track.appendChild(clone);
          copies += 1;
        }

        const styles = window.getComputedStyle(this.track);
        const gap = parseFloat(styles.columnGap || styles.gap) || 0;
        const distance = this.original.offsetWidth + gap;
        const speed = parseFloat(this.dataset.speed) || 40;
        const duration = distance / Math.max(speed, 1);

        this.style.setProperty('--scroll-distance', distance + 'px');
        this.style.setProperty('--scrolling-bar-duration', duration + 's');
        this.playVideos();
      }

      playVideos() {
        this.querySelectorAll('.scrolling-bar__video[data-autoplay="true"]').forEach((video) => {
          video.muted = true;
          video.playsInline = true;
          const play = function () {
            const promise = video.play();
            if (promise && promise.catch) promise.catch(function () {});
          };
          if (video.readyState >= 2) play();
          else video.addEventListener('canplay', play, { once: true });
        });
      }

      toggleVideos(shouldPlay) {
        this.querySelectorAll('.scrolling-bar__video').forEach((video) => {
          if (shouldPlay && video.dataset.autoplay === 'true') {
            const promise = video.play();
            if (promise && promise.catch) promise.catch(function () {});
          } else {
            video.pause();
          }
        });
      }

      disconnectedCallback() {
        if (this.resizeObserver) this.resizeObserver.disconnect();
        if (this.intersectionObserver) this.intersectionObserver.disconnect();
        window.removeEventListener('resize', this.fill);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-with-overlay"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('video-overlay-section')) {
    customElements.define('video-overlay-section', class VideoOverlaySection extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;

        this.source = this.dataset.source;
        this.autoplay = this.dataset.autoplay === 'true';
        this.loop = this.dataset.loop === 'true';
        this.startMuted = this.dataset.muted === 'true';
        this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        this.playButton = this.querySelector('[data-video-play]');
        this.muteButton = this.querySelector('[data-video-mute]');
        this.cover = this.querySelector('[data-video-cover]');
        this.labels = {
          play: this.dataset.labelPlay || 'Play',
          pause: this.dataset.labelPause || 'Pause',
          mute: this.dataset.labelMute || 'Mute',
          unmute: this.dataset.labelUnmute || 'Unmute'
        };

        if (this.playButton) {
          this.playButton.addEventListener('click', () => this.togglePlay());
        }
        if (this.muteButton) {
          this.muteButton.addEventListener('click', () => this.toggleMute());
        }
        if (this.cover) {
          this.cover.addEventListener('click', () => {
            if (!this.classList.contains('is-playing')) this.togglePlay();
          });
        }

        if (this.source === 'html5') this.setupHtml5();
        else if (this.source === 'youtube') this.setupYouTube();
        else if (this.source === 'vimeo') this.setupVimeo();
      }

      setupHtml5() {
        this.media = this.querySelector('video');
        if (!this.media) return;

        // Swap in the mobile poster frame when a mobile video is in use.
        const mobilePoster = this.media.dataset.posterMobile;
        if (mobilePoster && window.matchMedia('(max-width: 719px)').matches) {
          this.media.poster = mobilePoster;
        }

        this.media.muted = this.startMuted;
        this.media.loop = this.loop;
        this.media.playsInline = true;

        this.media.addEventListener('play', () => this.sync());
        this.media.addEventListener('pause', () => this.sync());
        this.media.addEventListener('volumechange', () => this.sync());

        if (this.autoplay && !this.reduceMotion) {
          this.media.muted = true;
          const playPromise = this.media.play();
          if (playPromise && playPromise.catch) playPromise.catch(() => {});
        }

        this.sync();
      }

      setupYouTube() {
        const iframe = this.querySelector('iframe');
        if (!iframe) return;

        this.loadYouTubeAPI().then((YT) => {
          this.player = new YT.Player(iframe, {
            events: {
              onReady: (event) => {
                if (this.startMuted || this.autoplay) event.target.mute();
                else event.target.unMute();

                if (this.autoplay && !this.reduceMotion) event.target.playVideo();
                this.sync();
              },
              onStateChange: () => this.sync()
            }
          });
        }).catch(() => {});
      }

      setupVimeo() {
        const iframe = this.querySelector('iframe');
        if (!iframe) return;

        this.loadVimeoAPI().then((Vimeo) => {
          this.player = new Vimeo.Player(iframe);
          this.player.setLoop(this.loop);
          this.player.setMuted(this.startMuted || this.autoplay);

          if (this.autoplay && !this.reduceMotion) {
            this.player.play().catch(() => {});
          }

          this.player.on('play', () => this.sync());
          this.player.on('pause', () => this.sync());
          this.player.on('volumechange', () => this.sync());
          this.sync();
        }).catch(() => {});
      }

      loadYouTubeAPI() {
        if (window.YT && window.YT.Player) return Promise.resolve(window.YT);
        if (!window.__graceYouTubeAPI) {
          window.__graceYouTubeAPI = new Promise((resolve) => {
            const previous = window.onYouTubeIframeAPIReady;
            window.onYouTubeIframeAPIReady = function () {
              if (typeof previous === 'function') previous();
              resolve(window.YT);
            };
            const script = document.createElement('script');
            script.src = 'https://www.youtube.com/iframe_api';
            document.head.appendChild(script);
          });
        }
        return window.__graceYouTubeAPI;
      }

      loadVimeoAPI() {
        if (window.Vimeo && window.Vimeo.Player) return Promise.resolve(window.Vimeo);
        if (!window.__graceVimeoAPI) {
          window.__graceVimeoAPI = new Promise((resolve, reject) => {
            const script = document.createElement('script');
            script.src = 'https://player.vimeo.com/api/player.js';
            script.onload = () => resolve(window.Vimeo);
            script.onerror = reject;
            document.head.appendChild(script);
          });
        }
        return window.__graceVimeoAPI;
      }

      togglePlay() {
        if (this.source === 'html5' && this.media) {
          if (this.media.paused) {
            const playPromise = this.media.play();
            if (playPromise && playPromise.catch) playPromise.catch(() => {});
          } else {
            this.media.pause();
          }
          return;
        }

        if (this.source === 'youtube' && this.player && typeof this.player.getPlayerState === 'function') {
          if (this.player.getPlayerState() === 1) this.player.pauseVideo();
          else this.player.playVideo();
          return;
        }

        if (this.source === 'vimeo' && this.player) {
          this.player.getPaused().then((paused) => {
            if (paused) this.player.play();
            else this.player.pause();
          });
        }
      }

      toggleMute() {
        if (this.source === 'html5' && this.media) {
          this.media.muted = !this.media.muted;
          this.sync();
          return;
        }

        if (this.source === 'youtube' && this.player && typeof this.player.isMuted === 'function') {
          if (this.player.isMuted()) this.player.unMute();
          else this.player.mute();
          this.sync();
          return;
        }

        if (this.source === 'vimeo' && this.player) {
          this.player.getMuted().then((muted) => {
            this.player.setMuted(!muted).then(() => this.sync());
          });
        }
      }

      sync() {
        let playing = this.classList.contains('is-playing');
        let muted = this.classList.contains('is-muted');

        if (this.source === 'html5' && this.media) {
          playing = !this.media.paused;
          muted = this.media.muted;
          this.updateState(playing, muted);
          return;
        }

        if (this.source === 'youtube' && this.player && typeof this.player.getPlayerState === 'function') {
          playing = this.player.getPlayerState() === 1;
          muted = typeof this.player.isMuted === 'function' ? this.player.isMuted() : muted;
          this.updateState(playing, muted);
          return;
        }

        if (this.source === 'vimeo' && this.player) {
          Promise.all([this.player.getPaused(), this.player.getMuted()]).then((result) => {
            this.updateState(!result[0], result[1]);
          }).catch(() => {});
        }
      }

      updateState(playing, muted) {
        this.classList.toggle('is-playing', playing);
        this.classList.toggle('is-muted', muted);

        if (this.cover) this.cover.hidden = playing;

        if (this.playButton) {
          this.playButton.setAttribute('aria-label', playing ? this.labels.pause : this.labels.play);
        }
        if (this.muteButton) {
          this.muteButton.setAttribute('aria-label', muted ? this.labels.unmute : this.labels.mute);
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('video-section')) {
    customElements.define('video-section', class VideoSection extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;

        this.source = this.dataset.source;
        this.autoplay = this.dataset.autoplay === 'true';
        this.loop = this.dataset.loop === 'true';
        this.startMuted = this.dataset.muted === 'true';
        this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        this.playButton = this.querySelector('[data-video-play]');
        this.muteButton = this.querySelector('[data-video-mute]');
        this.cover = this.querySelector('[data-video-cover]');
        this.labels = {
          play: this.dataset.labelPlay || 'Play',
          pause: this.dataset.labelPause || 'Pause',
          mute: this.dataset.labelMute || 'Mute',
          unmute: this.dataset.labelUnmute || 'Unmute'
        };

        if (this.playButton) {
          this.playButton.addEventListener('click', () => this.togglePlay());
        }
        if (this.muteButton) {
          this.muteButton.addEventListener('click', () => this.toggleMute());
        }
        if (this.cover) {
          this.cover.addEventListener('click', () => {
            if (!this.classList.contains('is-playing')) this.togglePlay();
          });
        }

        if (this.source === 'html5') this.setupHtml5();
        else if (this.source === 'youtube') this.setupYouTube();
        else if (this.source === 'vimeo') this.setupVimeo();
      }

      setupHtml5() {
        this.media = this.querySelector('video');
        if (!this.media) return;

        this.media.muted = this.startMuted;
        this.media.loop = this.loop;
        this.media.playsInline = true;

        this.media.addEventListener('play', () => this.sync());
        this.media.addEventListener('pause', () => this.sync());
        this.media.addEventListener('volumechange', () => this.sync());

        if (this.autoplay && !this.reduceMotion) {
          this.media.muted = true;
          const playPromise = this.media.play();
          if (playPromise && playPromise.catch) playPromise.catch(() => {});
        }

        this.sync();
      }

      setupYouTube() {
        const iframe = this.querySelector('iframe');
        if (!iframe) return;

        this.loadYouTubeAPI().then((YT) => {
          this.player = new YT.Player(iframe, {
            events: {
              onReady: (event) => {
                if (this.startMuted || this.autoplay) event.target.mute();
                else event.target.unMute();

                if (this.autoplay && !this.reduceMotion) event.target.playVideo();
                this.sync();
              },
              onStateChange: () => this.sync()
            }
          });
        }).catch(() => {});
      }

      setupVimeo() {
        const iframe = this.querySelector('iframe');
        if (!iframe) return;

        this.loadVimeoAPI().then((Vimeo) => {
          this.player = new Vimeo.Player(iframe);
          this.player.setLoop(this.loop);
          this.player.setMuted(this.startMuted || this.autoplay);

          if (this.autoplay && !this.reduceMotion) {
            this.player.play().catch(() => {});
          }

          this.player.on('play', () => this.sync());
          this.player.on('pause', () => this.sync());
          this.player.on('volumechange', () => this.sync());
          this.sync();
        }).catch(() => {});
      }

      loadYouTubeAPI() {
        if (window.YT && window.YT.Player) return Promise.resolve(window.YT);
        if (!window.__graceYouTubeAPI) {
          window.__graceYouTubeAPI = new Promise((resolve) => {
            const previous = window.onYouTubeIframeAPIReady;
            window.onYouTubeIframeAPIReady = function () {
              if (typeof previous === 'function') previous();
              resolve(window.YT);
            };
            const script = document.createElement('script');
            script.src = 'https://www.youtube.com/iframe_api';
            document.head.appendChild(script);
          });
        }
        return window.__graceYouTubeAPI;
      }

      loadVimeoAPI() {
        if (window.Vimeo && window.Vimeo.Player) return Promise.resolve(window.Vimeo);
        if (!window.__graceVimeoAPI) {
          window.__graceVimeoAPI = new Promise((resolve, reject) => {
            const script = document.createElement('script');
            script.src = 'https://player.vimeo.com/api/player.js';
            script.onload = () => resolve(window.Vimeo);
            script.onerror = reject;
            document.head.appendChild(script);
          });
        }
        return window.__graceVimeoAPI;
      }

      togglePlay() {
        if (this.source === 'html5' && this.media) {
          if (this.media.paused) {
            const playPromise = this.media.play();
            if (playPromise && playPromise.catch) playPromise.catch(() => {});
          } else {
            this.media.pause();
          }
          return;
        }

        if (this.source === 'youtube' && this.player && typeof this.player.getPlayerState === 'function') {
          if (this.player.getPlayerState() === 1) this.player.pauseVideo();
          else this.player.playVideo();
          return;
        }

        if (this.source === 'vimeo' && this.player) {
          this.player.getPaused().then((paused) => {
            if (paused) this.player.play();
            else this.player.pause();
          });
        }
      }

      toggleMute() {
        if (this.source === 'html5' && this.media) {
          this.media.muted = !this.media.muted;
          this.sync();
          return;
        }

        if (this.source === 'youtube' && this.player && typeof this.player.isMuted === 'function') {
          if (this.player.isMuted()) this.player.unMute();
          else this.player.mute();
          this.sync();
          return;
        }

        if (this.source === 'vimeo' && this.player) {
          this.player.getMuted().then((muted) => {
            this.player.setMuted(!muted).then(() => this.sync());
          });
        }
      }

      sync() {
        let playing = this.classList.contains('is-playing');
        let muted = this.classList.contains('is-muted');

        if (this.source === 'html5' && this.media) {
          playing = !this.media.paused;
          muted = this.media.muted;
          this.updateState(playing, muted);
          return;
        }

        if (this.source === 'youtube' && this.player && typeof this.player.getPlayerState === 'function') {
          playing = this.player.getPlayerState() === 1;
          muted = typeof this.player.isMuted === 'function' ? this.player.isMuted() : muted;
          this.updateState(playing, muted);
          return;
        }

        if (this.source === 'vimeo' && this.player) {
          Promise.all([this.player.getPaused(), this.player.getMuted()]).then((result) => {
            this.updateState(!result[0], result[1]);
          }).catch(() => {});
        }
      }

      updateState(playing, muted) {
        this.classList.toggle('is-playing', playing);
        this.classList.toggle('is-muted', muted);

        if (this.cover) this.cover.hidden = playing;

        if (this.playButton) {
          this.playButton.setAttribute('aria-label', playing ? this.labels.pause : this.labels.play);
        }
        if (this.muteButton) {
          this.muteButton.setAttribute('aria-label', muted ? this.labels.unmute : this.labels.mute);
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
